import React, { useState } from "react";
import classes from "./SideBar.module.css";
import { BlueLogo, logoWhite } from "../../constant/imagePath";
import { SideBarMenu } from "../../config/DummyData";
import { FaHome, FaUserCircle } from "react-icons/fa";
import { GiCheckMark } from "react-icons/gi";
import { MdNotifications } from "react-icons/md";
import {
  AiOutlineSchedule,
  AiOutlineTeam,
  AiOutlineUpload,
} from "react-icons/ai";
import { GrChannel } from "react-icons/gr";
import {
  BsCameraVideoFill,
  BsChatDots,
  BsFillCalendar2DateFill,
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
} from "react-icons/bs";
import { GiCloudUpload } from "react-icons/gi";
import { TbLogout } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../config/apiUrl";
import { io } from "socket.io-client";
import { signOutRequest } from "../../store/auth/authSlice";
import { RiArrowDownSFill, RiArrowUpSFill, RiMovieLine } from "react-icons/ri";

const SideBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, fcmToken } = useSelector((state) => state?.authReducer);
  const RenderItem = ({ icon, title, subMenu = [] }) => {
    const navigate = useNavigate();
    const active = useLocation()?.pathname;
    const [subnav, setSubnav] = useState(false);
    const subActive = subMenu.find((item, index) => item?.path == active);
    const showSubnav = () => setSubnav(!subnav);
    const currentPath = SideBarMenu.find((item) => item?.name == title)?.path;
    return (
      <>
        <div
          className={[
            classes?.listItemContainer,
            currentPath == active && classes?.active,
            subActive && classes?.subActive,
            subnav && classes?.marginZero,
          ].join(" ")}
          onClick={() => {
            if (subMenu?.length > 0) {
              showSubnav(!subnav);
            } else {
              navigate(currentPath);
            }
          }}
        >
          {icon}
          <span>{title}</span>
          {subMenu?.length > 0 &&
            (subnav ? (
              <RiArrowUpSFill
                size={20}
                color={"white"}
                className={classes?.dropDownIcon}
              />
            ) : (
              <RiArrowDownSFill
                size={20}
                color={"white"}
                className={classes?.dropDownIcon}
              />
            ))}
        </div>
        {subnav &&
          subMenu.map((item, index) => {
            return (
              <div
                className={[
                  classes?.innerItemContainer,
                  item?.path == active && classes?.active,
                ].join(" ")}
                key={index}
                onClick={() => {
                  navigate(item?.path);
                }}
              >
                {item?.icon}
                <span>{item.label}</span>
              </div>
            );
          })}
      </>
    );
  };

  const socket = useRef(null);

  const logout = () => {
    socket.current = io(apiUrl);
    socket.current.emit("logout", { _id: user?._id, fcmToken });
    dispatch(signOutRequest());
    navigate("/");
  };

  return (
    <div className={classes?.mainContainer}>
      <div className={classes?.logoContainer}>
        <img src={BlueLogo} onClick={() => navigate("/")} alt="..." />
      </div>
      <RenderItem icon={<FaHome size={22} />} title={"Dashboard"} />
      {user?.role == "admin" && (
        <>
          <RenderItem
            icon={<AiOutlineTeam size={20} />}
            title={"Team Member"}
          />
          <RenderItem icon={<RiMovieLine size={20} />} title={"Channels"} />
        </>
      )}
      <RenderItem
        icon={<BsCameraVideoFill size={20} />}
        title={"Videos"}
        subMenu={[
          {
            name: "All Videos",
            label: "All Videos",
            path: "/all-videos",
            icon: <BsCameraVideoFill />,
          },
          {
            name: "Upload",
            label: "Uploaded Videos",
            path: "/uploaded-videos",
            icon: <GiCloudUpload />,
          },
          {
            name: "Scheduled Videos",
            label: "Scheduled Videos",
            path: "/scheduled-videos",
            icon: <AiOutlineSchedule />,
          },
        ]}
      />
      <RenderItem icon={<FaUserCircle size={20} />} title={"My Profile"} />
      <RenderItem icon={<MdNotifications size={20} />} title={"Notifications"} />
      <RenderItem
        icon={<BsFillCameraVideoFill size={20} />}
        title={"Upload Video"}
      />
      {user?.role == "admin" && (
        <RenderItem
          icon={<BsFillCalendar2DateFill size={20} />}
          title={"Calendar"}
        />
      )}

    
      <div className={[classes?.listItemContainer].join(" ")} onClick={logout}>
        <TbLogout size={22} />
        <span>Logout</span>
      </div>
    </div>
  );
};

export default SideBar;
